module.exports = __webpack_public_path__ + "media/images/gradient-655fcf97c865e2664a2eb9f7de0ca255.svg";